import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import styled from 'styled-components';

import { withStyles } from '@material-ui/core/styles';

// material ui core imports
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
  Button,
  IconButton,
  Grid,
} from '@material-ui/core/';

// icons
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import uuid from 'uuid';

import { Redirect } from "react-router-dom";

// component imports
import {
  RegularCard,
  ItemGrid,
  CustomInput,
  UploadButton
} from "../../components";

// reducer action imports
import {
  loadFriends,
  createNewFriend,
  editFriend,
  deleteFriend,
  archiveFriendOffer
} from './reducer/actions';

// modal styled divs
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 0px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`

// custom modal styles
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

// custom table cell
const CustomTableCell = withStyles(theme => ({
  head: {
    textAlign: 'center'
  },

  body: {
    fontSize: 16,
    textAlign: 'center'
  },
}))(TableCell);

// root, table, and row styles
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

// Friends is fine, friends is good, everybody says it just like Robin Hood.

// class declaration
class FriendsList extends Component {
  // constructor with state
  constructor (props) {
    super(props);

    this.state = {
      isEditing: false,
      editingFriend: '',
      modal: null,

      name: '',
      aboutLocation: '',
      phone: '',
      email: '',
      site: '',
      location: '',
    };
    // binds
    this._onEditFriend = this._onEditFriend.bind(this);
    this._onCreateNewFriend = this._onCreateNewFriend.bind(this);
    this._onDeleteFriend = this._onDeleteFriend.bind(this);

  }

  // load Friends once component has mounted
  componentDidMount () {
    this.props.loadFriends();
  }

  // hide modal upon success
  _onSuccess () {
    this.setState({ modal: null });
  }

  // hide modal and log error on error
  _onError (error) {
    this.setState({ modal: null });
    console.log(error);
  }

  // delete a friend
  _onDeleteFriend (id) {
    this.props.deleteFriend(id, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // begin to edit a friend and put its info in the modal
  initEditFriend (id) {
    const { friends } = this.props;
    const curFriend = friends.filter(friend => (friend.id === id))[0];

    const coords = curFriend.coords || {};

    this.setState({
      name: curFriend.name,
      aboutLocation: curFriend.about,
      phone: curFriend.phone,
      email: curFriend.email,
      site: curFriend.site,
      location: curFriend.location,
      image: curFriend.image,
      coordsLat: coords.lat || null,
      coordsLng: coords.lng || null,
      isEditing: true,
      editingFriend: id,
      modal: 'edit'
    });
  }

  // called upon Editing a Friend
  _onEditFriend (id) {
    //const { friends } = this.props;
    //const curFriend = friends.filter(friend => (friend.id === id))[0];

    this.props.editFriend(id, {
      name: this.state.name,
      image: this.state.image || null,
      about: this.state.aboutLocation,
      phone: this.state.phone,
      email: this.state.email,
      site: this.state.site,
      location: this.state.location,
      coords: this.state.coordsLng && this.state.coordsLat ? ({
        lat: this.state.coordsLat,
        lng: this.state.coordsLng,
      }) : null,
      id: id
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // called upon pressing the Create button on the modal
  _onCreateNewFriend () {

    this.props.createNewFriend({
      name: this.state.name,
      image: this.state.image || null,
      about: this.state.aboutLocation,
      phone: this.state.phone,
      email: this.state.email,
      site: this.state.site,
      location: this.state.location,
      coords: this.state.coordsLng && this.state.coordsLat ? ({
        lat: this.state.coordsLat,
        lng: this.state.coordsLng,
      }) : null,
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // add an Offer to a Friend
  saveOffer() {
    const {
      offerEditingFriendId,
      offerId,
      offerName,
      offerTitle,
      offerSubTitle
    } = this.state;

    console.log('saveOffer', offerId, offerId || uuid.v4());

    const data = {
      offerId: offerId || uuid.v4(),
      offerName,
      offerTitle,
      offerSubTitle
    }

    this.props.editFriend(
      offerEditingFriendId,
      data,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // disable an Offer
  turnOffOffer() {
    const {
      offerEditingFriendId,
    } = this.state;

    const data = {
      offerId: null,
      offerName: null,
      offerTitle: null,
      offerSubTitle: null,
    }

    this.setState(data);

    this.props.editFriend(
      offerEditingFriendId,
      data,
      this._onSuccess.bind(this),
      this._onError.bind(this)
    );
  }

  // show the Edit Friend modal
  showEditModal () {
    this.setState({
      name: '',
      aboutLocation: '',
      phone: '',
      email: '',
      site: '',
      location: '',
      modal: 'edit'
    })
  }

  // close the modal
  _onCloseModal () {
    this.setState({ modal: null });
  }

  // Edit an Offer rather than disable it
  // TODO: this has not been implemented
  editOffers(id) {

  }

  // Archive an offer from a Friend
  archiveOffer() {
    const {
      offerEditingFriendId,
      offerId,
      offerName,
      offerTitle,
      offerSubTitle
    } = this.state;

    const data = {
      offerId,
      offerName,
      offerTitle,
      offerSubTitle
    }

    this.props.archiveFriendOffer(offerEditingFriendId, data,
      () => this.setState({
        offersArchive: {
          ...(this.state.offersArchive || {}),
          [offerId]: data
        },
        offerId: null,
        offerName: '',
        offerTitle: '',
        offerSubTitle: '',
      })
    );
  }

  // the Create/Edit Friend modal
  renderEditModal() {
    return (
      <ReactModal isOpen={this.state.modal === 'edit'}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.isEditing ? 'Edit Friend' : 'New Friend'}
        ariaHideApp={false}
        style={customModalStyles}
        >
        <ModalHeader>{this.state.isEditing ? 'Edit Friend' : 'New Friend'}</ModalHeader>
        <ModalContent>
          <Grid container>
            {/* Friend Name */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Name'
                id='name'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.name,
                  onChange: (e)=>this.setState({ name: e.target.value })
                }}
                />
            </ItemGrid>
            {/* Friend image */}
            <ItemGrid
              xs={12}
              sm={12}
              md={6}
              style={{
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex'
              }}>
              <UploadButton
                storage="friends"
                value={this.state.image}
                onUploadComplete={uri => this.setState({ image: uri })}
              />
            </ItemGrid>
          </Grid>
          <Grid container>
            {/* Friend email */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Email'
                id='email'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.email,
                  onChange: (e)=>this.setState({ email: e.target.value })
                }}
                />
            </ItemGrid>
            {/* Friend phone number */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Phone'
                id='phone'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.phone,
                  onChange: (e)=>this.setState({ phone: e.target.value })
                }}
                />
            </ItemGrid>
          </Grid>
          <Grid container>
            {/* Friend website */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Site'
                id='site'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.site,
                  onChange: (e)=>this.setState({ site: e.target.value })
                }}
                />
            </ItemGrid>
            {/* Friend street address */}
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='Street Address'
                id='location'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.location,
                  onChange: (e)=>this.setState({ location: e.target.value })
                }}
                />
            </ItemGrid>
            {/* Friend Latitude */}
            <ItemGrid xs={12} sm={12} md={6}>
              <CustomInput
                labelText='Latitude'
                id='lat'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.coordsLat,
                  onChange: (e)=>this.setState({ coordsLat: e.target.value })
                }}
                />
            </ItemGrid>
            {/* Friend Longitude */}
            <ItemGrid xs={12} sm={12} md={6}>
             <CustomInput
                labelText='Longitude'
                id='lng'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.coordsLng,
                  onChange: (e)=>this.setState({ coordsLng: e.target.value })
                }}
                />
            </ItemGrid>
            {/* Friend Info section */}
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='About Location'
                id='about'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.aboutLocation,
                  multiline: true,
                  rows: 2,
                  onChange: (e)=>this.setState({ aboutLocation: e.target.value })
                }}
                />
            </ItemGrid>
          </Grid>
        </ModalContent>
        {/* Edit/Create and Cancel buttons */}
        <ModalFooter>
          <Button variant='raised' primary={true} onClick={(e) => {this.state.isEditing ? this._onEditFriend(this.state.editingFriend) : this._onCreateNewFriend()} }>
            {this.state.isEditing ? 'Edit' : 'Create'}
          </Button>
          <Button variant='raised' style={{ marginLeft: 20 }} onClick={(e) => {this.setState({ isEditing: false, modal: null })}}>
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  // create or edit an Offer modal
  renderOfferModal() {
    const { offerEditingFriendId } = this.state;

    // get the Offer Archive for this Friend
    const archive = (this.props.friends.find(
      v => v.id === offerEditingFriendId)
      || {}).offersArchive;

    // if there is an archive, set this, otherwise null
    const archiveLoader = archive ? (
      <Grid container>
        <ItemGrid xs={12} sm={12} md={12}>
          <FormControl
            fullWidth
            style={{backgroundColor: '#eee', marginTop: '2rem'}}
          >
            <InputLabel htmlFor="archive">
              Load offer from archive...
            </InputLabel>
            {/* retrieve an archived offer from the Select */}
            <Select
              value={this.state.archiveValue}
              onChange={({ target: {value}}) => {
                this.setState({
                  archiveValue: value,
                  ...(archive[value] || {})
                })
              }}
              fullWidth
              inputProps={{
                name: 'archive',
                id: 'archive',
              }}
            >
              <MenuItem value="">
                <em>Cancel</em>
              </MenuItem>
                {Object.keys(archive).map(id =>
                  <MenuItem key={id}
                    value={id}
                  >
                    {archive[id].offerName || archive[id].offerTitle}
                  </MenuItem>
                )}
            </Select>
          </FormControl>
        </ItemGrid>
      </Grid>
    ) : null;

    // render offer modal return statement
    return (
      <ReactModal isOpen={this.state.modal === 'offer'}
        onRequestClose={this._onCloseModal.bind(this)}
        closeTimeoutMS={450}
        contentLabel={this.state.offerId ? 'Edit Offer' : 'New Offer'}
        ariaHideApp={false}
        style={customModalStyles}
        >
        <ModalHeader>
          {this.state.offerId ? 'Edit Offer' : 'New Offer'}
        </ModalHeader>
        <ModalContent>
          <Grid container>
            {/* Offer Name */}
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='Offer Name'
                id='offerName'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.offerName,
                  onChange: (e)=>this.setState({ offerName: e.target.value })
                }}
                />
            </ItemGrid>
            {/* Offer Title */}
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='Offer Title'
                id='offerTitle'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.offerTitle,
                  onChange: (e)=>this.setState({ offerTitle: e.target.value })
                }}
                />
            </ItemGrid>
            {/* Offer Subtitle */}
            <ItemGrid xs={12} sm={12} md={12}>
              <CustomInput
                labelText='Offer Sub Title'
                id='offerSubTitle'
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  value: this.state.offerSubTitle,
                  onChange: (e)=>this.setState({ offerSubTitle: e.target.value })
                }}
                />
            </ItemGrid>
          </Grid>
          {/* pull in old Offers, if applicable */}
         {archiveLoader}
        </ModalContent>
        <ModalFooter>
          {/* Edit/Save the current offer */}
          {this.state.offerId && (
            <Button
              variant='raised'
              primary={true}
              onClick={() => this.saveOffer() }
            >
              Save Changes
            </Button>
            )
          }
          {/* Archive the current existing offer */}
          {this.state.offerId && (
            <Button
              style={{ marginLeft: 20 }}
              variant='raised'
              primary={true}
              onClick={() => this.archiveOffer() }
            >
              Archive
            </Button>
            )
          }
          {/* Create a new offer */}
          {!this.state.offerId && (
            <Button
              variant='raised'
              primary={true}
              onClick={() => this.saveOffer() }
            >
              Create New
            </Button>
            )}
          {/* Deactivate an offer */}
          {!this.state.offerId && (
            <Button
              variant='raised'
              style={{ marginLeft: 20 }}
              primary={true}
              onClick={(e) => this.turnOffOffer() }
            >
              Turn Off
            </Button>
            )}
            {/* Cancel and close modal */}
          <Button variant='raised' style={{ marginLeft: 20 }} onClick={(e) => {this.setState({ isEditing: false, modal: null })}}>
            Cancel
          </Button>
        </ModalFooter>
      </ReactModal>
    );
  }

  // main render statement
  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'friends'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    if (!this.props.user.admin.master &&
      !this.props.user.admin.hasOwnProperty('friends'))
    {
      return (
        <Redirect from={'friends'} to={'dashboard'} key={'noTicket'} />
      );
    }

    // set props
    const { classes, friends, isLoading } = this.props;
    // render return
    return (
      <RegularCard
        cardTitle="Friends"
        cardSubtitle="Community and Sponsors"
        content={
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {/* Top row describing table contents */}
                <CustomTableCell>
                  Image
                </CustomTableCell>
                <CustomTableCell>
                  Name
                </CustomTableCell>
                <CustomTableCell>
                  Email
                </CustomTableCell>
                <CustomTableCell>
                  Phone
                </CustomTableCell>
                <CustomTableCell>
                  Location
                </CustomTableCell>
                <CustomTableCell>
                  Offer
                </CustomTableCell>
                <CustomTableCell>
                  Actions
                </CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {/* If still loading, display a Round Boi */}
            {isLoading && <div style={{padding: 10, textAlign: 'center'}}>
              <CircularProgress /> </div>
            }
            {/* If fully loaded, map Friends to the table */}
            {!isLoading && !isEmpty(friends) && friends.map(n => {
              const { offerId } = n;
              // map return
              return (
              <TableRow
                className={classes.row}
                key={n.id}
              >
                {/* Display Friend Image */}
                <CustomTableCell>
                  <div
                    style={{
                      width: 128,
                      height: 64,
                      backgroundColor: '#ccc',
                      backgroundImage: `url("${n.image}")`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: '50% 50%'
                    }}/>
                </CustomTableCell>
                {/* Display Friend Name */}
                <CustomTableCell>
                  {n.name}
                </CustomTableCell>
                {/* Display Friend Email */}
                <CustomTableCell>
                  {n.email}
                </CustomTableCell>
                {/* Display Friend Phone */}
                <CustomTableCell>
                  {n.phone}
                </CustomTableCell>
                {/* Display Friend Street Address */}
                <CustomTableCell>
                  {n.location}
                </CustomTableCell>
                {/* Offer Creation button */}
                <CustomTableCell>
                  <Button
                    style={{background: offerId ? '#a4c888' : '#8fbbe3'}}
                    onClick={() => this.setState({
                      modal: 'offer',
                      offerEditingFriendId: n.id,
                      offerId: n.offerId,
                      offerName: n.offerName || '',
                      offerTitle: n.offerTitle || '',
                      offerSubTitle: n.offerSubTitle || '',
                      archiveValue: null,
                    })}>
                    { offerId ? 'ACTIVE' : 'CREATE'}
                  </Button>
                </CustomTableCell>
                {/* Edit or Delete Friend buttons */}
                <CustomTableCell>
                  <IconButton
                    tooltip="Edit friend"
                    iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                    onClick={(e) => this.initEditFriend(n.id)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    tooltip="Delete friend"
                    iconStyle={{ fill: 'rgb(15, 102, 128)' }}
                    onClick={(e) => {this._onDeleteFriend(n.id)}}
                  >
                    <DeleteIcon />
                  </IconButton>
                </CustomTableCell>
              </TableRow>
              );
            })} {/* end of mapped Friends */}
              <TableRow>
                {/* Footer enables adding new Friends */}
                <TableCell colSpan={6}>
                  <Button
                    style={{background: '#E5e5e5'}}
                    onClick={() => this.showEditModal()}
                  >
                    Add New Friend
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
            {/* Show the Create/Edit Friend modal
              or the Create/Edit Offer modal
              or no modal at all
              */}
            {
              this.state.modal === 'edit' ? this.renderEditModal() :
              this.state.modal === 'offer' ? this.renderOfferModal() :
              null}
          </Table>
        }
      >


      </RegularCard>
    ); // end of render return
  } // end of render
} // end of class declaration

FriendsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  friends: state.friendReducer.friends,
  isLoading: state.friendReducer.isLoading,
  user: state.authReducer.user,
  loggedIn: state.authReducer.loggedIn,
});

const mapDispatchToProps = {
  loadFriends,
  createNewFriend,
  editFriend,
  archiveFriendOffer,
  deleteFriend
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FriendsList));
